angular.module('dpw.components')
    .component('dpwSecondaryNavSection', {
        bindings: {
            data: '<'
        },
        templateUrl: 'dpw-secondary-nav-section.html',
        controller: [function () {
            var self = this;

            Object.defineProperty(self, 'groups', {
                get: function () {
                    var data = self.data || {};
                    return data.groups || [];
                }
            });
        }]
    });
